// src/components/common/SignUpPromptModal.tsx
// Reusable modal that prompts guests to sign up or log in.
// Shown in place of direct /signup redirects so the user stays on the current page.

import React from 'react';
import { useNavigate } from 'react-router-dom';

interface SignUpPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  condoId?: string;
}

const SignUpPromptModal: React.FC<SignUpPromptModalProps> = ({ isOpen, onClose, message, condoId }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSignUp = () => {
    if (condoId) {
      localStorage.setItem('pendingWaitlistCondoId', condoId);
    }
    navigate('/signup');
  };

  const handleLogIn = () => {
    if (condoId) {
      localStorage.setItem('pendingWaitlistCondoId', condoId);
    }
    navigate('/login');
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="relative bg-cream border-2 border-coffee rounded-xl p-6 shadow-[4px_4px_0px_#594A42] max-w-md w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        {/* ✕ dismiss button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-coffee/60 hover:text-coffee transition-colors text-lg leading-none"
          aria-label="Close"
        >
          ✕
        </button>

        <h3 className="text-coffee font-semibold text-lg mb-3 pr-6">
          Join ShiYou to continue
        </h3>

        <p className="text-coffee/80 text-sm mb-6">{message}</p>

        <div className="flex space-x-2">
          <button
            onClick={handleSignUp}
            className="flex-1 bg-terracotta text-white border-2 border-coffee px-4 py-2 rounded-lg hover:bg-[#d89050] transition-colors font-medium"
          >
            Sign Up
          </button>
          <button
            onClick={handleLogIn}
            className="flex-1 bg-white border-2 border-coffee text-coffee px-4 py-2 rounded-lg hover:bg-cream transition-colors"
          >
            Log In
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignUpPromptModal;
